'use client';

import { SingleStoreType } from '@workspace/interfaces/store-locator';
import { InfoWindow } from '@vis.gl/react-google-maps';
import { memo } from 'react';

export const InfoWindowContent = memo(function InfoWindowContent({
  store,
  onClose,
  directionLabel,
}: {
  store: SingleStoreType | null;
  onClose: (store: SingleStoreType) => void;
  directionLabel: string | null | undefined;
}) {
  if (!store) return null;

  const mapLink = `https://www.google.com/maps/dir/?api=1&destination=${store._geoloc.lat},${store._geoloc.lng}`;

  return (
    <InfoWindow position={store._geoloc} onCloseClick={() => onClose(store)}>
      <div className="w-72 space-y-2 p-3">
        <div className="font-semibold text-base text-black">{store.storeName}</div>
        {store.address && <div className="text-sm text-secondary-600 leading-snug">{store.address}</div>}
        {store.storeTelephone && (
          <a href={`tel:${store.storeTelephone}`} className="block text-sm text-primary font-medium">
            {store.storeTelephone}
          </a>
        )}
        <div className="flex gap-2 pt-1">
          <a href={mapLink} target="_blank" rel="noreferrer" className="text-sm text-primary font-semibold underline">
            {directionLabel || 'Directions'}
          </a>
        </div>
      </div>
    </InfoWindow>
  );
});
